import moment from 'moment';
import * as Yup from 'yup';

const validationDobSchema = (isYPPlan: boolean) =>
  Yup.object()
    .test('dob-required', null, (schema) => {
      const { dob } = schema;
      if (!isYPPlan || dob) return true;
      return new Yup.ValidationError('Birthday is required', null, 'dob');
    })
    .test('is-dob-valid', null, (schema) => {
      const age = moment().diff(new Date(schema.dob), 'years');
      if (!isYPPlan || (age <= 30 && age >= 13)) return true;

      return new Yup.ValidationError('Must be 30 or under', null, 'dob');
    });

export default validationDobSchema;
